module.exports = new __parcel__URL__("doom.221ebb02.jpg").toString();